var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestaurantIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 6,
    fill: "#FF6A00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2320_2433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 7V10C12 10.55 12.45 11 13 11H13.5V14.5C13.5 14.775 13.725 15 14 15C14.275 15 14.5 14.775 14.5 14.5V5.565C14.5 5.24 14.195 5 13.88 5.075C12.8 5.34 12 6.255 12 7ZM9.5 8.5H8.5V5.5C8.5 5.225 8.275 5 8 5C7.725 5 7.5 5.225 7.5 5.5V8.5H6.5V5.5C6.5 5.225 6.275 5 6 5C5.725 5 5.5 5.225 5.5 5.5V8.5C5.5 9.605 6.395 10.5 7.5 10.5V14.5C7.5 14.775 7.725 15 8 15C8.275 15 8.5 14.775 8.5 14.5V10.5C9.605 10.5 10.5 9.605 10.5 8.5V5.5C10.5 5.225 10.275 5 10 5C9.725 5 9.5 5.225 9.5 5.5V8.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2320_2433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurantIcon);
export default __webpack_public_path__ + "static/media/restaurant_icon.5c0fd2222473fa048aa96c2980427fb9.svg";
export { ForwardRef as ReactComponent };